import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import type { ConversationsFilters } from '../../../lib/types';

// Conversas atribuíveis = sem dono (`assignedToUserId='unassigned'`) no pool dos
// times do supervisor (`teamQueue='mine'`). O fetch é gateado pelo `enabled`
// (cap + modal aberto), nunca só o render (lição feedback_gatear_fetch_nao_so_render).
const ASSIGNABLE_FILTERS: ConversationsFilters = {
  assignedToUserId: 'unassigned',
  teamQueue: 'mine',
};

export function useAssignableConversations(enabled: boolean) {
  return useQuery({
    queryKey: ['conversations', ASSIGNABLE_FILTERS],
    queryFn: () => api.listConversations(ASSIGNABLE_FILTERS),
    enabled,
    staleTime: 30_000,
  });
}
